import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './index.css'; // Tailwind styles
import './i18n';
import App from './App';
import "bootstrap/dist/js/bootstrap.bundle.min";

// Fetch profile branding before mounting app so `branding.js` proxy can pick it up
async function init() {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/branding`);
    if (res.ok) {
      const data = await res.json();
      if (data) window.__BRANDING__ = data;
    }
  } catch (e) {
    // Ignore — app will use default branding
    console.warn('Failed to load profile branding', e.message || e);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
}

init();
